import { Box } from "@mui/material";

const HorizontalFill = () => <Box flexGrow={1} />;
export default HorizontalFill;
